import { INode } from 'shared/types/tree'
import * as React from 'react'
import { getPresentationLeaf } from './utility'

export function PresentationSlidesView({
  presentation,
  useSourceFile,
}: {
  presentation: INode
  useSourceFile?: boolean
}) {
  const [url, setUrl] = React.useState('')

  React.useEffect(() => {
    const leaf = getPresentationLeaf(presentation)
    if (useSourceFile) {
      setUrl(leaf?.body?.source_file?.url)
    } else {
      setUrl(leaf?.body?.file?.url)
    }
  }, [presentation, useSourceFile])

  return <SlidesView url={url} />
}

export function SlidesView({ url }: { url: string }) {
  return <iframe title="Slides View" width="600" height="350" src={url} />
}
